import React, { useEffect, useMemo, useState } from "react";
import { useMarketSnapshot } from "../../context/MarketSnapshotContext";
import { useMarketIndicators } from "../../context/MarketIndicatorContext";

const Dropdown = () => {
  const {
    dashboardMarketData,
    dashboardLoading,
    dashboardError,
    loadDashboardIndexMarket,
  } = useMarketSnapshot();

  const { getLatestNseData, latestNseData } = useMarketIndicators();

  const [selectedIndex, setSelectedIndex] = useState("NIFTY 50");

  const nseIndicesOptions = ["NIFTY 50", "NIFTY BANK"];

  const indexSymbolData = latestNseData?.data;

  const dataToRender = useMemo(() => {
    if (!Array.isArray(indexSymbolData)) return [];

    return indexSymbolData.filter((item) => item?.priority !== 1);
  }, [indexSymbolData]);

  const handleIndexSelect = (e) => {
    const value = e.target.value;
    setSelectedIndex(value);

    if (!value) return;

    getLatestNseData(value);
  };

  useEffect(() => {
    getLatestNseData(selectedIndex);
  }, []);

  useEffect(() => {
    if (!selectedIndex) return;
    if (!Array.isArray(latestNseData?.data)) return;

    loadDashboardIndexMarket({
      indexName: selectedIndex,
      stocks: latestNseData.data,
    });
  }, [latestNseData, selectedIndex]);

  useEffect(() => {
    console.log("Selected Index:", selectedIndex);
    console.log("NSE Data:", latestNseData);
    console.log("Data To Render:", dataToRender);
    console.log("Dashboard Market Data:", dashboardMarketData);
    console.log("Loading:", dashboardLoading);
    console.log("Error:", dashboardError);
  }, [
    selectedIndex,
    latestNseData,
    dataToRender,
    dashboardMarketData,
    dashboardLoading,
    dashboardError,
  ]);

  return (
    <div className="select-option dropdown select-index-dropdown">
      <label className="test-page-label" style={{ textAlign: "center" }}>
        Choose Index
      </label>

      <select
        onChange={handleIndexSelect}
        value={selectedIndex}
        className="stocktest-inner-select"
      >
        <option value="">Select</option>

        {nseIndicesOptions.map((item) => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </select>

      {dashboardLoading && <p>Loading dashboard market data...</p>}

      {dashboardError && <p style={{ color: "red" }}>{dashboardError}</p>}

      <pre style={{ color: "white", fontSize: "12px" }}>
        {JSON.stringify(dashboardMarketData, null, 2)}
      </pre>
    </div>
  );
};

export default Dropdown;
